import { isDefined } from "@clipboard-health/util-ts";
import { type ListItemButtonProps, type ListItemTextProps } from "@mui/material";
import {
  type CbhIconProps,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@src/appV2/redesign/system/ui-components";

export interface AccountListItemProps {
  primaryText: ListItemTextProps["primary"];
  onClick: ListItemButtonProps["onClick"];
  iconType?: CbhIconProps["type"];
  secondaryText?: ListItemTextProps["secondary"];
  fullWidthDivider?: boolean;
}

export function AccountListItem(props: AccountListItemProps) {
  const { primaryText, iconType, secondaryText, onClick, fullWidthDivider = false } = props;

  return (
    <ListItemButton
      divider
      dividerOffset={
        isDefined(iconType) && !fullWidthDivider
          ? // ensure divider starts from the text, not the icon
            9
          : 0
      }
      sx={(theme) => ({ paddingY: isDefined(secondaryText) ? theme.spacing(4) : theme.spacing(6) })}
      onClick={onClick}
    >
      {isDefined(iconType) && <ListItemIcon iconType={iconType} />}
      <ListItemText
        primary={primaryText}
        secondary={secondaryText}
        sx={(theme) => ({ paddingLeft: `calc(${theme.spacing(1)} / 2)` })}
      />
    </ListItemButton>
  );
}
